import { getShopIndexApi } from '@/api/shop';
import { GetShopIndexApi, GetShopIndexParams } from '@/api/shop/type';
import { useCategoryStore } from '@/store/modules/category';
type DataFilterFunction<T> = (data: Array<T>) => Array<T>;
/**
 * 用户关联商城 品牌等数据相关hook
 */

export function useAccountSetting() {
  const categoryStore = useCategoryStore();

  async function init() {
    await categoryStore.initData();
  }

  return { init };
}
